import Err from "@Broker/@Routes/error";
import { LOAD_ACCOUNT_PLAN_DETAILS, PAYMENT_UPDATE_NOTIFICATION } from "@Broker/@Modules/account-plan/store/account-plan-actions";
import { WS_REFRESH_HIERARCHY_DETAILS } from "@Broker/@Modules/main/store/account/account-actions";
import { NO_DATA_RETRIEVED, SUCCESSFUL_DATA_RETRIEVED } from "@Broker/@Modules/clients/reports/store/reports-actions";
import { UPDATE_GENERATED_LENDER_NOTE, DEAL_IMPORT_COMPLETE_NOTIFICATION } from "@Broker/@Modules/clients/applications/application/store/application-actions";
import { LOAD_BOARDS } from "@Broker/@Modules/clients/board/store/board-actions";
import { UPDATE_EXTRACTED_DOCUMENT_VALUES } from "@Broker/@Modules/clients/applications/documents/store/documents-actions";
export const SOCKET_MESSAGE = "SOCKET_MESSAGE";
const WebsocketEventsToActionMap = {
  HIERARCHY_CHANGE: `AccountStore/${WS_REFRESH_HIERARCHY_DETAILS}`,
  STRIPE_SUCCESSFUL_PAYMENT: `AccountPlanStore/${LOAD_ACCOUNT_PLAN_DETAILS}`,
  REPORTING_NO_RESULTS: `ReportsStore/${NO_DATA_RETRIEVED}`,
  REPORTING_SUCCESSFUL_RESULTS: `ReportsStore/${SUCCESSFUL_DATA_RETRIEVED}`,
  AI_LENDER_NOTES_GENERATION_COMPLETED: `ApplicationStore/${UPDATE_GENERATED_LENDER_NOTE}`,
  AI_VALUE_EXTRACTION_COMPLETED: `DocumentsStore/${UPDATE_EXTRACTED_DOCUMENT_VALUES}`,
  COLLABORATOR_UPDATE: `BoardStore/${LOAD_BOARDS}`
};
const WebsocketEventsToNotificationMap = {
  STRIPE_SUCCESSFUL_PAYMENT: {
    action: `AccountPlanStore/${PAYMENT_UPDATE_NOTIFICATION}`,
    message: "subscribedBy",
    type: "success"
  },
  EXPERT_DATA_TRANSFER_COMPLETED: {
    action: `ApplicationStore/${DEAL_IMPORT_COMPLETE_NOTIFICATION}`,
    message: "importHasFinishedMessage",
    type: "success"
  }
};
const actions = {
  [SOCKET_MESSAGE]: async (context, {
    event,
    data
  }) => {
    const actionToCall = WebsocketEventsToActionMap[event];
    const notificationToCall = WebsocketEventsToNotificationMap[event];
    try {
      if (actionToCall) {
        context.dispatch(actionToCall, data, {
          root: true
        });
      }
      if (notificationToCall) {
        context.dispatch(notificationToCall.action, {
          data,
          notification: notificationToCall
        }, {
          root: true
        });
      }
    } catch (e) {
      Err.handle(e, {});
    }
  }
};
export default actions;